export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "Web Development",    link: "/catalog/web-development" },
      { title: "Data Science",       link: "/catalog/data-science" },
      { title: "Machine Learning",   link: "/catalog/machine-learning" },
      { title: "Mobile Development", link: "/catalog/mobile-development" },
      { title: "DevOps",             link: "/catalog/devops" },
      { title: "AI / ML Tools",      link: "/catalog/ai-ml-tools" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "Python",      link: "/python" },
      { title: "JavaScript",  link: "/javascript" },
      { title: "Java",        link: "/java" },
      { title: "C / C++",     link: "/c++" },
      { title: "TypeScript",  link: "/typescript" },
      { title: "Kotlin",      link: "/kotlin" },
    ],
  },
];
